import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import ManageProducts from 'src/components/Elements/ManageProducts';

const ProductManagementModal = () => (
  <ModalBase
    name={MODALS.manageProducts}
    size={MODALS_SIZE.small}>
    <ManageProducts />
  </ModalBase>
);

export default ProductManagementModal;
